import { get, uniqBy } from 'lodash';
import * as immutable from 'object-path-immutable';
import { useQuery } from '@apollo/client';

import GET_TASK_LIST_TEMPLATES from '../gql/getTaskListTemplates.graphql';
import { TEMPLATES_PER_PAGE } from './constants';

const useCompanyTemplates = (includePartnerTemplates = false) => {
  const DEFAULT_PAGEINFO = { hasNextPage: false, endCursor: null };
  const pageInfo = (data) =>
    get(data, 'viewer.company.taskListTemplates.pageInfo', DEFAULT_PAGEINFO);

  const nodes = (data) => {
    return get(data, 'viewer.company.taskListTemplates.nodes', []);
  };

  const { data, loading, error, fetchMore } = useQuery(
    GET_TASK_LIST_TEMPLATES,
    {
      fetchPolicy: 'cache-and-network',
      variables: { first: TEMPLATES_PER_PAGE, includePartnerTemplates },
    },
  );

  const mergeNewPage = (oldData, newData) => {
    if (!newData) {
      return oldData;
    }
    const updatedNodes = uniqBy(
      uniqBy([...nodes(oldData), ...nodes(newData)], (node) => node.id),
    );

    return immutable.set(
      newData,
      'viewer.company.taskListTemplates.nodes',
      updatedNodes,
    );
  };

  const fetchNextPage = () => {
    fetchMore({
      variables: {
        first: TEMPLATES_PER_PAGE,
        after: pageInfo(data).endCursor,
        includePartnerTemplates,
      },
      updateQuery: (prev, { fetchMoreResult }) =>
        mergeNewPage(prev, fetchMoreResult),
    });
  };

  return {
    companyTemplates: nodes(data),
    loading,
    error,
    hasNextPage: pageInfo(data).hasNextPage,
    fetchNextPage,
  };
};

export default useCompanyTemplates;
